var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridSwitcherLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.6C2 2.71634 2.74619 2 3.66667 2H20.3333C21.2538 2 22 2.71634 22 3.6V6C22 6.88366 21.2538 7.6 20.3333 7.6H3.66667C2.74619 7.6 2 6.88366 2 6V3.6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.8C2 9.9163 2.74619 9.19995 3.66667 9.19995H20.3333C21.2538 9.19995 22 9.9163 22 10.8V13.2C22 14.0836 21.2538 14.8 20.3333 14.8H3.66667C2.74619 14.8 2 14.0836 2 13.2V10.8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.9999C2 17.1162 2.74619 16.3999 3.66667 16.3999H20.3333C21.2538 16.3999 22 17.1162 22 17.9999V20.3999C22 21.2836 21.2538 21.9999 20.3333 21.9999H3.66667C2.74619 21.9999 2 21.2836 2 20.3999V17.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridSwitcherLines);
export default __webpack_public_path__ + "static/media/grid-switcher-lines.a8de16faaf08802a5b575d12b928151c.svg";
export { ForwardRef as ReactComponent };